// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"kp-z","breadcrumbForward":"lp-z","breadcrumbBack":"mp-z","selected":"np-z"};